import imageFragment from "./image";

const cartFragment = /* GraphQL */ `
  fragment cart on Cart {
    id
    checkoutUrl
    cost {
      subtotalAmount { amount currencyCode }
      totalAmount { amount currencyCode }
      totalTaxAmount { amount currencyCode }
      totalDutyAmount { amount currencyCode }
    }
    lines(first: 100) {
      edges { node {
        id
        quantity
        cost { totalAmount { amount currencyCode } }
        attributes {
          key
          value
        }
        merchandise {
          ... on ProductVariant {
            id
            title
            selectedOptions { name value }
            product {
              id
              handle
              title
              featuredImage { ...image }
              collections(first: 5) {
                edges { node {
                  title
                  handle
                } }
              }
              set_items: metafield(namespace: "custom", key: "set_items") { value }
            }
          }
        }
      } }
    }
    totalQuantity
  }
  ${imageFragment}
`;

export default cartFragment;


